import { SelectElementMapper } from '../../_services/types/commons.type';
import { SharedFunnelDatalayerEvent } from '../../_services/types/datalayer.types';
import {
  BusinessAccidentPayment,
  getBusinessAccidentPaymentLabel,
} from '../../enums/claim/business/business-accident-payment.enum';
import {
  BusinessAccidentType,
  getBusinessAccidentTypeLabel,
} from '../../enums/claim/business/business-accident-type.enum';
import {
  BusinessEmploymentType,
  getBusinessEmploymentTypeLabel,
} from '../../enums/claim/business/business-employment-type.enum';
import {
  BusinessSalaryType,
  getBusinessSalaryTypeLabel,
} from '../../enums/claim/business/business-salary-type.enum';

export const BUSINESS_ACCIDENT_BASE_URL = 'accident-professionnel';

export const BUSINESS_ACCIDENT_FUNNEL_EVENT_BASE: SharedFunnelDatalayerEvent = {
  product_category: 'LAA',
  product_name: 'Claim',
  funnel_complete: false,
  get event() {
    return `${this.product_name}_${this.product_category}`;
  },
};

export const BUSINESS_ACCIDENT_STEPS = {
  EMPLOYEE: {
    url: 'employee',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_ACCIDENT_FUNNEL_EVENT_BASE,
      funnel_stage: 4,
      stage_name: 'Employee',
    },
  },
  ACCIDENT_DETAILS: {
    url: 'details-accident',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_ACCIDENT_FUNNEL_EVENT_BASE,
      funnel_stage: 5,
      stage_name: 'Details accident',
    },
  },
  EMPLOYMENT_SITUATION: {
    url: 'situation',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_ACCIDENT_FUNNEL_EVENT_BASE,
      funnel_stage: 6,
      stage_name: 'Situation pro',
    },
  },
  INCAPACITY: {
    url: 'incapacite',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_ACCIDENT_FUNNEL_EVENT_BASE,
      funnel_stage: 7,
      stage_name: 'Incapacite',
    },
  },
  SALARY: {
    url: 'salaire',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_ACCIDENT_FUNNEL_EVENT_BASE,
      funnel_stage: 8,
      stage_name: 'Salaire',
    },
  },
  DOCUMENTS: {
    url: 'documents',
    step: [3, 1],
    datalayerEvent: {
      ...BUSINESS_ACCIDENT_FUNNEL_EVENT_BASE,
      funnel_stage: 9,
      stage_name: 'Documents',
    },
  },
  VALIDATION: {
    url: 'validation',
    step: [4, 1],
    datalayerEvent: {
      ...BUSINESS_ACCIDENT_FUNNEL_EVENT_BASE,
      funnel_stage: 10,
      stage_name: 'Validation',
    },
  },
} as const;

export const BUSINESS_ACCIDENT_ACCIDENT_TYPE_OPTIONS: SelectElementMapper<BusinessAccidentType> = {
  [BusinessAccidentType.PROFESSIONAL]: {
    value: BusinessAccidentType.PROFESSIONAL,
    label: getBusinessAccidentTypeLabel(BusinessAccidentType.PROFESSIONAL),
  },
  [BusinessAccidentType.COMMUTING]: {
    value: BusinessAccidentType.COMMUTING,
    label: getBusinessAccidentTypeLabel(BusinessAccidentType.COMMUTING),
  },
  [BusinessAccidentType.LEISURE]: {
    value: BusinessAccidentType.LEISURE,
    label: getBusinessAccidentTypeLabel(BusinessAccidentType.LEISURE),
  },
};

export const BUSINESS_ACCIDENT_EMPLOYMENT_TYPE_OPTIONS: SelectElementMapper<BusinessEmploymentType> =
  {
    [BusinessEmploymentType.CDI]: {
      value: BusinessEmploymentType.CDI,
      label: getBusinessEmploymentTypeLabel(BusinessEmploymentType.CDI),
    },
    [BusinessEmploymentType.CDD]: {
      value: BusinessEmploymentType.CDD,
      label: getBusinessEmploymentTypeLabel(BusinessEmploymentType.CDD),
    },
    [BusinessEmploymentType.TEMPORARY]: {
      value: BusinessEmploymentType.TEMPORARY,
      label: getBusinessEmploymentTypeLabel(BusinessEmploymentType.TEMPORARY),
    },
    [BusinessEmploymentType.APPRENTICESHIP]: {
      value: BusinessEmploymentType.APPRENTICESHIP,
      label: getBusinessEmploymentTypeLabel(BusinessEmploymentType.APPRENTICESHIP),
    },
  };

export const BUSINESS_ACCIDENT_SALARY_TYPE_OPTIONS: SelectElementMapper<BusinessSalaryType> = {
  [BusinessSalaryType.MONTHLY]: {
    value: BusinessSalaryType.MONTHLY,
    label: getBusinessSalaryTypeLabel(BusinessSalaryType.MONTHLY),
  },
  [BusinessSalaryType.HOURLY]: {
    value: BusinessSalaryType.HOURLY,
    label: getBusinessSalaryTypeLabel(BusinessSalaryType.HOURLY),
  },
};

export const BUSINESS_ACCIDENT_PAYMENT_OPTIONS: SelectElementMapper<BusinessAccidentPayment> = {
  [BusinessAccidentPayment.EMPLOYER]: {
    value: BusinessAccidentPayment.EMPLOYER,
    label: getBusinessAccidentPaymentLabel(BusinessAccidentPayment.EMPLOYER),
  },
  [BusinessAccidentPayment.EMPLOYEE]: {
    value: BusinessAccidentPayment.EMPLOYEE,
    label: getBusinessAccidentPaymentLabel(BusinessAccidentPayment.EMPLOYEE),
  },
};
